export const onAuthenticationOk = ({ trackingId: _ }: { trackingId: string }) => {
    // console.log('authentication ok', trackingId);
    console.log('authentication OK');
};
